/**
 * Este header evita que o HttpInterceptor adicione headers
 * nos endpoints da API consumidos antes do login do usuario, ou seja,
 * antes do frontend possuir o JWT de autenticao.
 */
// necessário tirar da classe http-interceptor.service.ts para evitar erro de dependência cíclica com o autenticacaoService ( quando a autenticaService precisar fazer um skip de header )
export const InterceptorPreLogin = 'X-PreLogin';
